import { Tooltip } from 'components/Tooltip';

import { useUsersContext } from 'contexts/UsersContext';

import * as S from './Tabs.styles';

import { TabType } from './types';

type TabsProps = {
  tabs: TabType[];
  saveUser: () => void;
};

const defaultProps: Partial<TabsProps> = {};

export function Tabs(props: TabsProps): React.ReactElement {
  const { tabs, saveUser } = { ...defaultProps, ...props };
  const { form } = useUsersContext();

  const tabsFiltered = tabs?.filter((tab: TabType) => !tab.isHidden);

  const titlesMapped = tabsFiltered?.map((tab: TabType) => (
    <S.Tab
      onClick={async () => form?.formState?.isDirty && saveUser()}
      disabled={tab.isDisabled}
      key={tab.id}
    >
      {tab.isDisabled ? (
        <Tooltip text="To access this tab please create user first">{tab.title}</Tooltip>
      ) : (
        tab.title
      )}
    </S.Tab>
  ));

  const panelsMapped = tabsFiltered?.map((tab: TabType) => (
    <S.Panel key={tab.id}>{tab.content}</S.Panel>
  ));

  return (
    <S.Tabs>
      <S.List>{titlesMapped}</S.List>

      {panelsMapped}
    </S.Tabs>
  );
}
